import React from 'react';
import { DataStateItem } from 'shared/types';
import { concatString } from 'shared/utils';
import { Drilldown } from '../Drilldown';

interface TemplateFieldProps {
  fieldKeys: string[];
  record: DataStateItem;
  drillDown?: {
    drilldownKey: string | number;
    onDrilldown: (drilldownKey: string | number) => void;
  };
}

export const TemplateField: React.FC<TemplateFieldProps> = React.memo((props) => {
  const { record, fieldKeys, drillDown } = props;

  const templateString = concatString(
    fieldKeys.map((key) => record[key] as string),
  );

  if (drillDown && record && drillDown.drilldownKey && record[drillDown.drilldownKey]) {
    return (
      <Drilldown onClick={() => drillDown.onDrilldown(record[drillDown.drilldownKey] as string | number)}>
        {templateString}
      </Drilldown>
    );
  }

  return templateString;
});
